<template>
  <li class="nav-item" :class="{ 'has-sub': children }">
    <template v-if="!children">
      <router-link :to="path">
        <i :class="iconClassName"></i>
        <span class="menu-title">{{title}}</span>
        <span
          class="tag tag-pill float-xs-right mr-0"
          :class="notifyTagColor"
          v-if="notify"
        >{{notify}}</span>
      </router-link>
    </template>
    <template v-else>
      <a>
        <i :class="iconClassName"></i>
        <span class="menu-title">{{title}}</span>
      </a>
      <ul class="menu-content" v-if="children">
        <li v-for="child in children" :key="child.title">
          <router-link :to="child.path" class="menu-item">{{child.title}}</router-link>
        </li>
      </ul>
    </template>
  </li>
</template>

<script>
export default {
  name: "LeftMenuItem",
  props: {
    iconClassName: String,
    title: String,
    path: String,
    children: Array,
    notify: Number,
    notifyTagColor: String,
  },
};
</script>